export default __webpack_public_path__ + "static/media/music-game.df137637.mp3";